import React from 'react';
import { Send } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import HoneypotField from './HoneypotField';
import { FIELD_SANITIZERS } from '../../lib/contactSanitizers';

const ContactForm = ({ formData, isSubmitting, onChange, onSubmit }) => {
  const handleSanitizedChange = (e) => {
    const { name, value } = e.target;
    const fn = FIELD_SANITIZERS[name];
    const cleaned = fn ? fn(value) : value;
    if (cleaned !== value) {
      onChange({ target: { name, value: cleaned } });
    } else {
      onChange(e);
    }
  };

  return (
    <form onSubmit={onSubmit} className="space-y-6">
      <HoneypotField value={formData.website} onChange={handleSanitizedChange} />

      <div>
        <Label htmlFor="name">Full Name *</Label>
        <Input
          id="name" name="name" type="text"
          value={formData.name} onChange={handleSanitizedChange}
          required minLength={2} maxLength={80} autoComplete="name"
          placeholder="John Smith"
          className="mt-2"
          data-testid="contact-name-input"
        />
      </div>

      <div>
        <Label htmlFor="email">Email Address *</Label>
        <Input
          id="email" name="email" type="email"
          value={formData.email} onChange={handleSanitizedChange}
          required maxLength={120} autoComplete="email"
          placeholder="john@example.com"
          className="mt-2"
          data-testid="contact-email-input"
        />
      </div>

      <div>
        <Label htmlFor="phone">Phone Number *</Label>
        <Input
          id="phone" name="phone" type="tel"
          value={formData.phone} onChange={handleSanitizedChange}
          required minLength={7} maxLength={25}
          inputMode="tel" pattern="[\d+()\-.\s]{7,}" autoComplete="tel"
          title="Numbers, spaces, parentheses, dashes, dots only"
          placeholder="(919) 555-1234"
          className="mt-2"
          data-testid="contact-phone-input"
        />
      </div>

      <div>
        <Label htmlFor="message">Message *</Label>
        <Textarea
          id="message" name="message"
          value={formData.message} onChange={handleSanitizedChange}
          required minLength={5} maxLength={2000} rows={6}
          placeholder="Tell us about your needs and how we can help..."
          className="mt-2"
          data-testid="contact-message-input"
        />
        <p className="mt-1 text-xs text-gray-400 text-right">
          {formData.message.length}/2000
        </p>
      </div>

      <Button
        type="submit" size="lg"
        className="w-full bg-coral-500 hover:bg-coral-600 text-white"
        disabled={isSubmitting}
        data-testid="contact-submit-button"
      >
        {isSubmitting ? 'Sending...' : (
          <>
            <Send className="w-5 h-5 mr-2" />
            I&apos;m Ready To Bring-A-Nurse
          </>
        )}
      </Button>

      <p className="text-sm text-gray-500 text-center">
        By submitting this form, you agree to be contacted by Bring-A-Nurse Senior Companion PLLC
      </p>
    </form>
  );
};

export default ContactForm;
